<a [href]="location.prepareExternalUrl('')" class="nav-brand">
  <img [src]="portalSettings.logo" alt="">
  {{portalSettings.name}}
</a>
